import type React from 'react';

export interface BookmarkIconProps {
  width?: string | number;
  height?: string | number;
  color?: string;
  'aria-label'?: string;
}

const BookmarkIcon: React.FC<BookmarkIconProps> = ({
  width = 17,
  height = 17,
  color = 'white',
  'aria-label': ariaLabel = 'Bookmark Icon',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
  >
    <path
      d="M1.0625 4.046V15.2841C1.0625 15.4746 1.12377 15.6311 1.24631 15.7537C1.36885 15.8762 1.52575 15.9375 1.717 15.9375H15.2841C15.4746 15.9375 15.6311 15.8762 15.7537 15.7537C15.8762 15.6311 15.9375 15.4746 15.9375 15.2841V4.046H11.6875V11.2582L8.5 9.6645L5.3125 11.2582V4.046H1.0625ZM1.717 17C1.241 17 0.835833 16.8328 0.5015 16.4985C0.167167 16.1642 0 15.7594 0 15.2841V3.70388C0 3.49704 0.0329374 3.30225 0.0988124 3.1195C0.164687 2.93675 0.263854 2.76852 0.396313 2.61481L2.05169 0.627938C2.2054 0.420396 2.39771 0.263854 2.62862 0.158313C2.85954 0.052771 3.1071 0 3.37131 0H13.5883C13.8518 0 14.1026 0.052771 14.3406 0.158313C14.5786 0.263854 14.7744 0.420042 14.9281 0.626875L16.6037 2.65625C16.7361 2.80996 16.8353 2.98173 16.9012 3.17156C16.9671 3.36069 17 3.55902 17 3.76656V15.2841C17 15.7586 16.8328 16.1635 16.4985 16.4985C16.1642 16.8328 15.7594 17 15.2841 17H1.717ZM1.46625 2.9835H15.5125L14.0994 1.28562C14.0307 1.21763 13.952 1.16344 13.8635 1.12306C13.775 1.08269 13.6829 1.0625 13.5872 1.0625H3.3915C3.29658 1.0625 3.2045 1.08304 3.11525 1.12413C3.026 1.16521 2.94808 1.21975 2.8815 1.28775L1.46625 2.9835ZM6.37394 4.046V9.52106L8.49894 8.45856L10.6239 9.52106V4.04706L6.37394 4.046Z"
      fill={color}
    />
  </svg>
);

export default BookmarkIcon;

